import * as actionTypes from './actionTypes';
import { getSelectedItemId } from '../selectors/selectionSelectors';
// @ts-expect-error not yet migrated
import { clearSelectedItem } from './selectionActions';
import { getCurrentGridLayoutSectionToAddTo } from '../selectors/sectionsSelectors';
export const setNodeStyles = (nodeId, gridLayoutId, isEditorProvidedModuleStyles, activeBreakpoint, styles) => ({
  type: actionTypes.GRID_LAYOUTS_SET_NODE_STYLES,
  payload: {
    nodeId,
    gridLayoutId,
    isEditorProvidedModuleStyles,
    activeBreakpoint,
    styles
  }
});
export const setOldModuleStyles = (nodeId, gridLayoutId, styles) => ({
  type: actionTypes.GRID_SET_OLD_MODULE_STYLES,
  payload: {
    nodeId,
    gridLayoutId,
    styles
  }
});
export const setContainerLayoutType = (nodeId, gridLayoutId, activeBreakpoint, layoutType) => ({
  type: actionTypes.GRID_LAYOUTS_UPDATE_NODE_LAYOUT,
  payload: {
    nodeId,
    gridLayoutId,
    activeBreakpoint,
    layoutType
  }
});
export const updateGridTableDefinition = (nodeId, gridLayoutId, activeBreakpoint, newRows, newColumns) => ({
  type: actionTypes.GRID_LAYOUTS_UPDATE_TABLE_DEFINITION,
  payload: {
    nodeId,
    gridLayoutId,
    activeBreakpoint,
    newRows,
    newColumns
  }
});
export const cloneNodeAndInsertAfterOriginalInGridLayout = (gridLayoutId, nodeId) => dispatch => {
  dispatch({
    type: actionTypes.GRID_LAYOUTS_NODE_CLONED_AND_INSERTED_AFTER_ORIGINAL,
    payload: {
      gridLayoutId,
      nodeId
    }
  });
};
export const deleteContainerFromGridLayout = (gridLayoutId, nodeId) => (dispatch, getState) => {
  const state = getState();
  const selectedItemId = getSelectedItemId(state);
  if (selectedItemId === nodeId) {
    dispatch(clearSelectedItem());
  }
  dispatch({
    type: actionTypes.GRID_LAYOUTS_CONTAINER_DELETED,
    payload: {
      gridLayoutId,
      nodeId
    }
  });
};
export const deleteSectionFromGridLayout = (gridLayoutId, nodeId) => (dispatch, getState) => {
  const state = getState();
  const selectedItemId = getSelectedItemId(state);
  if (selectedItemId === nodeId) {
    dispatch(clearSelectedItem());
  }
  dispatch({
    type: actionTypes.GRID_LAYOUTS_SECTION_DELETED,
    payload: {
      gridLayoutId,
      nodeId
    }
  });
};
export const insertBlankSectionInGridLayout = newSectionLayout => (dispatch, getState) => {
  const state = getState();
  const currentGridLayoutSectionToAddTo = getCurrentGridLayoutSectionToAddTo(state);
  if (currentGridLayoutSectionToAddTo) {
    dispatch({
      type: actionTypes.GRID_LAYOUTS_INSERT_BLANK_SECTION,
      payload: {
        gridLayoutId: currentGridLayoutSectionToAddTo.gridLayoutId,
        beforeNodeId: currentGridLayoutSectionToAddTo.beforeNodeId,
        afterNodeId: currentGridLayoutSectionToAddTo.afterNodeId,
        newSectionLayout
      }
    });
  } else {
    console.error('No current grid layout section to add to');
  }
};
export const deleteModuleFromGridLayout = (gridLayoutId, nodeId) => (dispatch, getState) => {
  const state = getState();
  const selectedItem = getSelectedItemId(state);
  if (selectedItem === nodeId) {
    dispatch(clearSelectedItem());
  }
  dispatch({
    type: actionTypes.GRID_LAYOUTS_MODULE_DELETED,
    payload: {
      gridLayoutId,
      nodeId
    }
  });
};